// extracted by mini-css-extract-plugin
module.exports = {"sale-button":"_1Zyuu","saleButton":"_1Zyuu","divider-color":"_29PnS","dividerColor":"_29PnS","disclaimer":"_2b3rk","disclaimer-standalone":"_3cqND","disclaimerStandalone":"_3cqND"};